module.exports = __webpack_public_path__ + "img/9788932908816.d95a05b9.jpg";